import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CostTypePage } from './cost-type.page';
import { CostTypeDialogModule } from './cost-type-dialog/cost-type-dialog.module';


export * from './cost-type.page';
export * from './cost-type-dialog/cost-type-dialog.module';
export * from './cost-type-group-dialog/cost-type-group-dialog.module';

const routes: Routes = [
    {
        path: '',
        component: CostTypePage,
    },
];

@NgModule({
    declarations: [ CostTypePage ],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        MatIconModule,
        MatInputModule,
        MatButtonModule,
        MatTableModule,
        MatPaginatorModule,
        CostTypeDialogModule,
        MatProgressBarModule,
        TranslateModule,
        MatTooltipModule
    ],
})
export class CostTypePageModule {
}
